const module = {
  routes: [
    {
      path: '/controllers',
      component: () => import('@/modules/controllers/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
